import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import createSelectors from '~/hooks/stores/createSelectors'
import type {
  MobilizeEventsPageInfo,
  MobilizeStoreType
} from '~/types/mobilize'

export const EVENTS_PAGE_SIZE = 10

export const eventsInitialState: MobilizeEventsPageInfo = {
  page: 0,
  pageSize: EVENTS_PAGE_SIZE,
  total: 0,
  syncableTotal: 0,
  data: [],
  errorMessage: '',
  loadRequestId: 0,
  searchTerm: '',
  sortBy: '',
  sortDirection: 'desc',
  tagIds: [],
  tagCollectionId: null
}

export const mobilizeInitialState: MobilizeStoreType = {
  events: { ...eventsInitialState },
  loading: {
    events: false
  }
}

const useMobilizeStoreBase = create<MobilizeStoreType>()(
  immer(() => ({
    ...mobilizeInitialState
  }))
)

const useMobilizeStore = createSelectors(useMobilizeStoreBase)

export default useMobilizeStore
